export const UNASSIGNED_CLUSTER = 'Not Assigned'
export const GPU_NOT_CONFIGURED = 'Not Configured'
